import {Icon} from '@/app/components/Icon';
import {useGetAbbreviationsQuery} from '../../../app/services/abbreviationApi';
interface AbbreviationLongNameProps {
  shortName: string;
}
export const AbbreviationLongName = ({shortName}: AbbreviationLongNameProps) => {
  const {data: abbreviations, isFetching} = useGetAbbreviationsQuery(
    {
      shortName,
      shortNameMatchMode: 3,
    },
    {
      skip: !shortName,
    },
  );
  const abbreviation = abbreviations?.find((abbreviation) => abbreviation.shortName === shortName);
  return (
    <span>
      {isFetching && <Icon icon="spinner" spin />}
      {!isFetching && (abbreviation?.longName ?? shortName)}
    </span>
  );
};
